import { api } from '../../services/api';
import * as types from '../Constants';
import { getCached, setCache } from '../../Common/apiCache';

export const getProfileClientTag = (id) => {
  const options = {
    url: `v1/client/AssignTag/All/${id}`,
  };
  options.types = [types.GET_PROFILE_CLIENT_TAG_SUCCESS, types.GET_PROFILE_CLIENT_TAG_FAILURE];

  return api.get(options);
};

export const addProfileClientTag = (data) => {
  const options = {
    url: 'v1/client/AssignTag',
  };
  options.types = [types.ADD_PROFILE_CLIENT_TAG_SUCCESS, types.ADD_PROFILE_CLIENT_TAG_FAILURE];
  return api.post(options, data);
};

export const removeProfileClientTag = (data) => {
  const options = {
    url: 'v1/client/AssignTag',
  };
  options.types = [
    types.DELETE_PROFILE_CLIENT_TAG_SUCCESS,
    types.DELETE_PROFILE_CLIENT_TAG_FAILURE,
  ];

  return api.delete(options, data);
};

export const getClientSource = () => {
  const cached = getCached('clientSource');
  if (cached) {
    return (dispatch) =>
      Promise.resolve(dispatch({ type: types.GET_CLIENT_SOURCE_LISTING_SUCCESS, payload: cached }));
  }
  const options = {
    url: 'v1/config/GetAllClientSource',
  };
  options.types = [
    types.GET_CLIENT_SOURCE_LISTING_SUCCESS,
    types.GET_CLIENT_SOURCE_LISTING_FAILURE,
  ];
  const apiAction = api.get(options);
  return (dispatch) =>
    apiAction(dispatch).then((result) => {
      if (result && result.payload) setCache('clientSource', result.payload);
      return result;
    });
};
